export const addressFactory = '5a2a927bea6c5f4a48d4e0116049c1e36d52a528'
export const addressRouter = 'df60e3babacfce81c9efcb268c14a7d33efe567b'
export const addressGetBalancesResolver = 'a57b9a85b63899b9d46c5a9c35bf53de7ea1c488'
